import React from "react";
import Offer from "../Offer/Offer";
import "./cart.css";
import type { ProductItem } from "../../types/catalog";
import { useI18n } from "../../i18n/I18n";

interface CartProps {
  active: boolean;
  setActive: React.Dispatch<React.SetStateAction<boolean>>;
  offer: ProductItem[];
  setOffer: React.Dispatch<React.SetStateAction<ProductItem[]>>;
  setOfferDoneActive: React.Dispatch<React.SetStateAction<boolean>>;
}

function Cart({ active, setActive, offer, setOffer, setOfferDoneActive }: CartProps) {
  const { t } = useI18n();
  return <div className={active?"cart active":"cart"} onMouseDown={()=>setActive(false)}>
    <div className="cart__content" onMouseDown={e=>e.stopPropagation()}>
      <h2 className="cart__content-header">{t("yourCart")}</h2>
      <div className="cart__content-offers">{offer.length===0?<p className="cart__content-text">{t("emptyCart")}</p>:offer.map(el=><Offer key={el.id} {...el} offers={offer} setOffers={setOffer}/>)}</div>
      <button className="cart__content-button" disabled={!offer.length} onClick={()=>{setActive(false);setOfferDoneActive(true)}}>{t("checkout")}</button>
    </div>
  </div>;
}
export default Cart;
